(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('roleService', roleService);

    roleService.$inject = ['$http', 'CONFIG', 'messageService'];

    function roleService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/roles';
        var service = {
            getPageRoles: getPageRoles,
            getRoles: getRoles,
            getRole: getRole,
            getRoleByClient: getRoleByClient,
            saveRole: saveRole,
            updateRole: updateRole,
            deleteRole: deleteRole
        }

        return service;

        function getPageRoles(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getRoles(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.roles : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getRole(roleId){
            return $http.get(urlBase + "/" + roleId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('roles')
                });
        }

        function getRoleByClient(clientId){
            return $http.get(urlBase + "/byClient/" + clientId+ '?all=false')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('roles')
                });
        }

        function saveRole(role){
            return $http.post(urlBase, role)
                .then(function(response){
                    messageService.register('roles');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('roles');
                });
        }

        function updateRole(role, roleId){
            return $http.put(urlBase + "/" + roleId, role)
                .then(function(response){
                    messageService.registerUpdate('roles');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('roles')
                });
        }

        function deleteRole(roleId){
            return $http.delete(urlBase + "/" + roleId)
                .then(function(response){
                    messageService.registerDelete('roles');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('roles');
                });
        }
    }
})();
